<template>
    <teleport to="body">
        <div :class="['alert-wrap', theme]">
            <h4 v-if="myTitle || title" class="alert-title" v-text="myTitle || title"></h4>
            <div class="alert-content">
                <div v-if="myContent || content" v-text="myContent || content"></div>
                <slot></slot>
            </div>
            <a href="javascript:;" :class="['alert-btn', operationType, theme]" @click="clickConfirm" v-text="myButtonText || buttonText"></a>
            <slot name="footer"></slot>
            <MaskLayer v-if="clickMaskClose" @onClickMask="closeAlert" :opacity="maskOpacity" />
            <MaskLayer v-if="!clickMaskClose" />
        </div>
    </teleport>
</template>

<script setup>
import { getCurrentInstance, ref, computed } from 'vue';
import MaskLayer from './MaskLayer.vue';

const { proxy } = getCurrentInstance();

const props = defineProps({
    title: {
        type: String,
        default: '',
    },
    content: {
        type: String,
        default: '',
    },
    buttonText: {
        type: String,
        default: '确定',
    },
    theme: {
        type: String,
        default: 'purple',
    },
    maskOpacity: {
        type: Number,
        default: 0.5,
    },
    autoClose: {
        type: Boolean,
        default: true,
    },
    clickMaskClose: {
        type: Boolean,
        default: true,
    },
    // square || circle
    operationType: {
        type: String,
        default: 'square',
    },
});


const emits = defineEmits(['onClose', 'onConfirm']);

const clickConfirm = () => {
    emits('onConfirm');
    
    if(props.autoClose){
        emits('onClose');
        proxy?.onClose && proxy?.onClose();
    }
};

const closeAlert = () => {
    emits('onClose');
    proxy?.onClose && proxy?.onClose();
};
</script>

<style lang="scss" scoped>
.alert-wrap{
    position: fixed;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 580px;
    padding-top: 48px;
    box-sizing: border-box;
    background: #ffffff;
    border-radius: 32px;
    z-index: 1000001;
    
    .alert-title{
        margin-top: 16px;
        margin-bottom: 32px;
        padding: 0 48px;
        font-size: 36px;
        font-family: PingFangSC, PingFangSC-Semibold;
        font-weight: 700;
        text-align: center;
        color: #1f2a36;
        line-height: 1
    }
    .alert-content{
        font-size: 24px;
        font-family: PingFangSC, PingFangSC-Regular;
        font-weight: 400;
        color: #1f2a36;
        line-height: 36px;
        text-align: center;
        padding: 10px 48px 20px 48px;
        white-space: pre-wrap;
    }
    .alert-btn{
        display: flex;
        align-items: center;
        justify-content: center;

        font-size: 28px;
        font-family: PingFangSC, PingFangSC-Medium;
        font-weight: 500;
        text-align: center;
        line-height: 28px;

        &.circle{
            margin: 32px auto 48px auto;
            width: 384px;
            height: 80px;
            border-radius: 48px;
            &.purple{
                background: #8965ff;
                color: #ffffff;
            }
            &.yellow{
                background: #FFC52C;
                color: #1F2A36;
            }
        }

        &.square{
            margin-top: 44px;
            font-size: 32px;
            font-family: PingFangSC, PingFangSC-Medium;
            font-weight: 500;
            color: #8965ff;
            width: 100%;
            height: 96px;
            background: #f4f4fc;
            border-radius: 0 0 32px 32px;
        }
    }
}
</style>
